// src/pages/Moderation/ModerationQueueDetailsPage/ui/QueueDetailsHeader/QueueDetailsHeader.tsx
import React from 'react';
import './QueueDetailsHeader.scss';

export const QueueDetailsHeader: React.FC<{ title: string; subtitle?: string }> = ({
  title,
  subtitle,
}) => {
  return (
    <div className="mq-details-header">
      <div className="mq-details-header__title">{title}</div>
      {subtitle && <div className="mq-details-header__subtitle">{subtitle}</div>}
    </div>
  );
};
